import undoRedoManager from './UndoRedoManager';
import { cancelPendingGridHistoryCommit } from './gridHistoryCommit';
import {
  bumpGridHistorySession,
  getGridHistorySessionId,
  setGridHistoryReady,
} from './gridHistorySuppress';
import {
  clearLastCommittedGridHistory,
  refreshLastCommittedGridHistory,
} from './gridHistoryBaseline';
import { getGridHistoryScene } from './gridHistory';

export { getGridHistorySessionId };

/**
 * Wipe undo/redo and open a new session.
 * Call when the grid starts, after project load, and after save/publish.
 * New edits then record as step 0, 1, 2, … in a fresh list.
 *
 * @param {{ ready?: boolean }} options
 *   ready=false while loading (no recording / no undo)
 *   ready=true when user edits may be recorded
 */
export function startFreshGridHistory(options = {}) {
  const ready = options.ready !== false;

  bumpGridHistorySession();
  cancelPendingGridHistoryCommit();
  undoRedoManager.clear();

  if (ready) {
    refreshLastCommittedGridHistory(getGridHistoryScene());
  } else {
    clearLastCommittedGridHistory();
  }

  setGridHistoryReady(ready);
  undoRedoManager.notify();

  return getGridHistorySessionId();
}
